<div class="button">
  <p-button [label]="label" [icon]="icon" [ariaLabel]="ariaLabel || label" (onClick)="clicked.emit()" />
</div>
